export enum LifecycleForm {
  CREATE = 'Create Lifecycle',
  EDIT = 'Edit Lifecycle',
}
